import React, { useState } from "react"
import { Button } from "react-bootstrap"
import { config } from "~/config"

export const ShareImageDownloadButton = (props: {
  getIdToken: () => Promise<string>
  path: string
  filename: string
  label: string
}) => {
  const [downloading, setDownloading] = useState(false)

  const handleDownload = async () => {
    setDownloading(true)
    try {
      const idToken = await props.getIdToken()
      const response = await fetch(`${config.apiUrl}${props.path}`, {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
      if (!response.ok) {
        const text = await response.text()
        alert(`ダウンロード失敗: ${response.status} ${text}`)
        return
      }
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = props.filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    } catch (e) {
      alert(`ダウンロードエラー: ${String(e)}`)
      console.error(e)
    } finally {
      setDownloading(false)
    }
  }

  return (
    <Button
      variant="outline-info"
      size="sm"
      onClick={handleDownload}
      disabled={downloading}
    >
      {downloading ? "DL中..." : props.label}
    </Button>
  )
}
